<template>
    <div class="info">
        <div class="title">投保企业信息</div>
        <Form :label-width="110" class="mt15">
            <FormItem label="企业名称：" class="w600">
                {{info.applicantList[0].subjectName}}
            </FormItem>
            <FormItem label="企业证件类型：" class="w600">
                {{info.applicantList[0].idTypeDesc}}
            </FormItem>
            <FormItem label="企业证件编码：" class="w600">
                {{info.applicantList[0].idNumber}}
            </FormItem>
            <FormItem label="企业地址：" class="w600">
                {{info.applicantList[0].provinceName}}
                {{info.applicantList[0].cityName}}
                {{info.applicantList[0].areaName}}
            </FormItem>
            <FormItem label="详细地址：" class="w600">
                {{info.applicantList[0].address}}
            </FormItem>
            <FormItem label="联系人姓名：" class="w600">
                {{info.applicantList[0].contactName}}
            </FormItem>
            <FormItem label="联系人电话：" class="w600">
                {{info.applicantList[0].contactPhone}}
            </FormItem>
            <FormItem label="联系人邮箱：" class="w600">
                {{info.applicantList[0].contactEmail}}
            </FormItem>
        <div class="title">被保企业信息</div>
            <FormItem label="企业名称：" class="w600">
                {{info.insuredList[0].subjectName}}
            </FormItem>
            <FormItem label="企业证件类型：" class="w600">
                {{info.insuredList[0].idTypeDesc}}
            </FormItem>
            <FormItem label="企业证件编码：" class="w600">
                {{info.insuredList[0].idNumber}}
            </FormItem>
        <div class="title">投保信息</div>
            <FormItem label="项目名称：" class="w600">
                {{info.extraInfo.projectName}}
            </FormItem>
            <FormItem label="项目编码：" class="w600">
                {{info.extraInfo.projectCode}}
            </FormItem>
            <FormItem label="保证金金额：" class="w600">
                {{info.insuranceAmount}}
            </FormItem>
            <FormItem label="起保日期：" class="w600">
                {{info.effectiveDateStart}}
            </FormItem>
            <FormItem label="终保日期：" class="w600">
                {{info.effectiveDateEnd}}
            </FormItem>
            <FormItem label="总费用：" class="w600">{{info.premium}}</FormItem>
        </Form>
    </div>
</template>
<script>
    export default {
        components: {},
        props: {
            info: Object,
            title: String
        },
        data () {
            return {

            }
        },
        created () {

        },
        methods: {}
    }
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/customizedEmployerLiability/common/ApplicantCompanyInfo.vue